var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottery-result-container"},[_c('h3',[_vm._v("最新开奖结果")]),_vm._l((_vm.resultData),function(result){return _c('Result',{key:result.lotterycode,attrs:{"result":result}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }